import { AnyAction, Tuple, combineReducers, configureStore, createAction } from "@reduxjs/toolkit";
import { Middleware } from "redux";
import { datesToString } from '../common'
import modulesReducer, { ModulesState, initModulesState } from "./module-slice";

import breadcrumbReducer, { BreadcrumbState, initBreadcrumbState } from "./breadcrumb-slice";
import settingsReducer, { SettingsState, initSettingsState } from "./settings-slice";
import notificationReducer, { NotificationState, initNotificationState } from "./notification-slice";
import messageBoxReducer, { initMessageBoxState, MessageBoxState } from './message-box.slice';
import currentUserReducer, { CurrentUserState, initCurrentUserState } from "./current-user-slice";
import { thunk } from "redux-thunk";
import iconsReducer, { IconsState, initIconsState } from "./icons-slice";
import socketDataReducer, { SocketDataState, initSocketState } from "./socket-data-slice";
import uxManagementReducer, { UXManagementState, initUxManagementState } from "./ux-management-slice";


//Try and keep the lists alphabetical please, pretty please.
export interface AppState {
  breadcrumbs: BreadcrumbState;
  currentUser: CurrentUserState;
  icons: IconsState;
  messageBox: MessageBoxState,
  modules: ModulesState;
  notifications: NotificationState;
  settings: SettingsState;
  socketData: SocketDataState;
  uxManagement: UXManagementState;
}

export const initializeAppState: AppState = {
  breadcrumbs: initBreadcrumbState,
  currentUser: initCurrentUserState,
  icons: initIconsState,
  messageBox: initMessageBoxState,
  modules: initModulesState,
  notifications: initNotificationState,
  settings: initSettingsState,
  socketData: initSocketState,
  uxManagement: initUxManagementState
}

export const dateMiddleware: Middleware = api => next => (action: any) => {

  if (action.payload) {
    action.payload = datesToString(action.payload)
  }
  if (action.meta) {
    action.meta = datesToString(action.payload)
  }
  return next(action);
};

export const resetAppState = createAction("app/resetState");

const appReducer = combineReducers({
  breadcrumbs: breadcrumbReducer,
  currentUser: currentUserReducer,
  icons: iconsReducer,
  messageBox: messageBoxReducer,
  modules: modulesReducer,
  notifications: notificationReducer,
  settings: settingsReducer,
  socketData: socketDataReducer,
  uxManagement: uxManagementReducer
});

const rootReducer = (state: AppState | undefined, action: AnyAction) => {
  if (action.type === resetAppState.type) {
    return appReducer(
      {
        ...state,
        currentUser: initCurrentUserState,
        modules: initModulesState,
        notifications: initNotificationState,
      } as AppState,
      action
    );
  }

  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: () => new Tuple(thunk, dateMiddleware)
})

